export default function Footer() {
  return (
    <footer className="mt-24 border-t-2 border-slate-200 bg-white">
      <div className="mx-auto max-w-6xl px-6 py-10 text-base text-slate-600">
        <p className="mb-2">
          <span className="font-semibold text-slate-900">LetterLifts</span> provides
          general document assistance — not legal, medical, or financial advice.
        </p>
        <p className="text-sm text-slate-500">
          Made with care for people who deserve clear answers.
        </p>
      </div>
    </footer>
  );
}
